<div class="max-w-6xl mx-auto my-10 grid grid-cols-1 md:grid-cols-3 gap-5 items-center">

    <!-- Participación Total -->
    <div class="bg-white dark:bg-[#19191c] rounded-xl shadow-md p-6 flex flex-col items-center justify-center border-l-4 border-green-700">
        <i class="pi pi-users text-gray-400 dark:text-gray-50 text-3xl mb-2"></i>
        <p class="text-green-800 dark:text-green-600 font-bold text-sm">PARTICIPACIÓN TOTAL</p>
        <div class="mt-2 flex items-center space-x-2">
            <span class="text-2xl font-bold text-gray-800 dark:text-[white]">
                {{ clampPct(participacionPct) | number : '1.0-1' }}%
            </span>
            <div class="relative w-16 h-5 bg-gray-200 rounded-full overflow-hidden">
                <div class="absolute top-0 left-0 h-full bg-green-600 rounded-full" [style.width.%]="clampPct(participacionPct)"></div>
            </div>
        </div>
    </div>

    <!-- Suma de Observaciones -->
    <div class="flex flex-col items-center justify-center">
        <div
            class="relative w-32 h-32 rounded-full bg-white dark:bg-[#19191c] border-4 border-t-blue-500 border-b-orange-500 flex items-center justify-center">
            <span class="text-3xl font-bold text-gray-700 dark:text-[white]">{{ (sumaTotal ?? 0) | number }}</span>
        </div>
        <span class="mt-2 text-md text-gray-600 font-medium dark:text-[white]">Suma de Obs</span>
    </div>

    <!-- Objetivo Total -->
    <div
        class="bg-white dark:bg-[#19191c] rounded-xl shadow-md p-6 flex flex-col items-center justify-center border-l-4 border-green-700">
        <i class="pi pi-user text-gray-400 dark:text-gray-50 text-3xl mb-2"></i>
        <p class="text-green-800 dark:text-green-600 font-bold text-sm">OBJETIVO TOTAL</p>

        <div class="mt-2 flex items-center space-x-2">
            <span class="text-2xl font-bold text-gray-800 dark:text-[white]">
                {{ clampPct(objetivoPct) | number : '1.0-1' }}%
            </span>
            <div class="relative w-16 h-5 bg-gray-200 rounded-full overflow-hidden">
                <div class="absolute top-0 left-0 h-full bg-green-600 rounded-full" [style.width.%]="clampPct(objetivoPct)"></div>
            </div>
        </div>
       
    </div>

</div>